import React from 'react'

type SVGProps = React.SVGProps<SVGSVGElement>

export function TwCircleCheck(props: SVGProps) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.333984 15.0007C0.333984 6.90047 6.90047 0.333984 15.0007 0.333984C23.1008 0.333984 29.6673 6.90047 29.6673 15.0007C29.6673 23.1008 23.1008 29.6673 15.0007 29.6673C6.90047 29.6673 0.333984 23.1008 0.333984 15.0007Z"
        className="fill-mint-500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0796 9.72461C22.6003 10.2453 22.6003 11.0895 22.0796 11.6102L13.8035 20.2769C13.2828 20.7976 12.4386 20.7976 11.9179 20.2769L7.91787 16.2769C7.39717 15.7562 7.39717 14.912 7.91787 14.3913C8.43857 13.8706 9.28279 13.8706 9.80349 14.3913L12.8607 17.4485L20.194 9.72461C20.7147 9.20391 21.5589 9.20391 22.0796 9.72461Z"
        fill="white"
      />
    </svg>
  )
}
